import { ResourceRepository, ResourceTypes } from '@telespot/domain';

export interface ICountResourcesQuery {
  /**
   * Counts resources matching an optional search term and optional type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(searchTerm?: string, type?: string): Promise<number>;
}

export class CountResourcesQuery implements ICountResourcesQuery {
  constructor(private readonly resourceRepository: ResourceRepository) {}

  public async execute(searchTerm?: string, type?: string): Promise<number> {
    return this.resourceRepository.count(searchTerm, type as ResourceTypes);
  }
}
